/* eslint-disable */

export default function getBoundingBox(data) {


    let bounds = {}, coords, i, j, k, l;

    const parseCoords = (lon, lat) => {
        bounds.xMin = bounds.xMin < lon ? bounds.xMin : lon;
        bounds.xMax = bounds.xMax > lon ? bounds.xMax : lon;
        bounds.yMin = bounds.yMin < lat ? bounds.yMin : lat;
        bounds.yMax = bounds.yMax > lat ? bounds.yMax : lat;
    }

    for (i = 0; i < data.features.length; i++) {
        coords = data.features[i].geometry.coordinates;

        // this can go a maximum of three levels deep for multipolygons
        for (j = 0; j < coords.length; j++) {
            if (!Array.isArray(coords[j][0])) {
                parseCoords(coords[j][0], coords[j][1])
            } else {
                for (k = 0; k < coords[j].length; k++) {
                    if (!Array.isArray(coords[j][k][0])) {
                        parseCoords(coords[j][k][0], coords[j][k][1])
                    } else {
                        for (l = 0; l < coords[j][k].length; l++) {
                            parseCoords(coords[j][k][l][0], coords[j][k][l][1])
                        }
                    }
                }
            }


        }
    }

    bounds = {
        xMin: bounds.xMin || 0,
        xMax: bounds.xMax || 0,
        yMin: bounds.yMin || 0,
        yMax: bounds.yMax || 0
    }  ;

    return bounds;
}
